// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-details[data-v-b458b08a]{padding:2rem 0}.order-details .details-container[data-v-b458b08a]{list-style:none;padding:0}.order-details .details-container p[data-v-b458b08a]{font-weight:400;margin:1.5rem 0 .5rem}.order-details .details-container .value[data-v-b458b08a]{margin:0 0 .3rem 0}", ""]);
// Exports
module.exports = exports;
